import React from 'react';
import PropTypes from 'prop-types';
import ReactFitText from 'react-fittext';
import styles from './home-culture-title.module.css';

const HomeCultureTitle = props => {
  const { animation } = props;
  return (
    <React.Fragment>
      <div className={styles.titleDesktop} style={animation}>
        <ReactFitText compressor={0.9} maxFontSize={80}>
          <h2 className={styles.title}>
            Being awesome<br></br> is encouraged.
          </h2>
        </ReactFitText>
      </div>
      <div className={styles.titleMobile} style={animation}>
        <ReactFitText compressor={1} maxFontSize={60}>
          <h2 className={styles.title}>
            Being awesome<br></br> is encouraged.
          </h2>
        </ReactFitText>
      </div>
    </React.Fragment>
  );
};

HomeCultureTitle.propTypes = {
  animation: PropTypes.object,
};

export default HomeCultureTitle;



// WEBPACK FOOTER //
// ./src/components/home/home-culture/home-culture-title/index.js